import { AGENCY_TYPES } from '@/store/modules/legal-entity/constants'
import util from '@/util'

export const formatEmployment = paymentInfo => {
  const paymentType = paymentInfo?.type
  const legalEntity = paymentInfo?.legal_entity

  if (!paymentType) {
    return ''
  }

  const normalizedPaymentType = String(paymentType).toLowerCase()
  let employmentType = util.capitalize(String(paymentType))

  if (normalizedPaymentType === 'contractor' && legalEntity) {
    const agencyType = AGENCY_TYPES[legalEntity.type] || ''
    employmentType = `${agencyType} ${
      legalEntity.type === 'agency' || legalEntity.type === 'marketplace' ? 'Contractor' : ''
    }`.trim()
  } else if (normalizedPaymentType === 'employee') {
    employmentType = `${util.capitalize(paymentInfo.method ?? '')} Employee`.trim()
  }

  return legalEntity?.name ? `${employmentType} from ${legalEntity.name}` : employmentType
}
